import React from 'react'
import { Table, TableHead, TableRow, TableCell } from '@mui/material'
;
import TableContainer from '@mui/material/TableContainer';


export default function useTableScroll(headCells) {

    const TblContainer = (props) => (
        <div  className='table-sm border-table p-0'  style={props.container}>
            <table className="table table-striped table-hover table-sm">
                {props.children}
            </table>
        </div>
    )

    const TblHead = () => {

        return (<thead style={{border: 'none'}}>
            <tr style={{border: 'none'}}>
                {
                    headCells.map((item, index) => (
                        <th  key={index} className='letra-tabla-th' style={{backgroundColor: 'rgba(5, 81, 130, 1)', fontWeight: 'bold', width: item.width, textAlign: item.textAlign}}>
                            {item.label}
                        </th>))
                }
            </tr>
        </thead>)
    }

    return {
        TblContainer,
        TblHead
    }
}

